import { render, staticRenderFns } from "./SinisterActions.vue?vue&type=template&id=de83d568&scoped=true"
import script from "./SinisterActions.vue?vue&type=script&lang=ts"
export * from "./SinisterActions.vue?vue&type=script&lang=ts"
import style0 from "./SinisterActions.vue?vue&type=style&index=0&id=de83d568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de83d568",
  null
  
)

export default component.exports